import { baseUrl_SPB } from '../BaseUrl';

function buildHeaders(token) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }

  return headers;
}

async function parseJsonResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return null;
  }

  return response.json();
}

export async function fetchPermissionSets(token) {
  const response = await fetch(`${baseUrl_SPB}/api/permission-sets`, {
    method: 'GET',
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error('Unable to fetch permission sets');
  }

  const payload = await parseJsonResponse(response);
  return Array.isArray(payload) ? payload : [];
}

export async function fetchUserAccess(token, userId) {
  const response = await fetch(`${baseUrl_SPB}/api/users/${encodeURIComponent(userId)}/permissions`, {
    method: 'GET',
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error('Unable to fetch user access');
  }

  const payload = await parseJsonResponse(response);
  return payload || {};
}

export async function updateUserPermissionSets(token, userId, permissionSetIds) {
  const response = await fetch(`${baseUrl_SPB}/api/users/${encodeURIComponent(userId)}/permissions`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify({
      permissionSetIds: Array.isArray(permissionSetIds) ? permissionSetIds : [],
    }),
  });

  if (!response.ok) {
    throw new Error('Unable to save user access');
  }

  return parseJsonResponse(response);
}
